export const EXISTING_EMAIL_ERROR = 409;
